import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ShipCollateralItemEntity, VehicleCollateralItemEntity } from '../../utils/collateral-item.utils';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

@Component({
  selector: 'nk-collateral-item',
  templateUrl: './collateral-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule, TooltipModule],
})
export class CollateralItemComponent {
  public item = input.required<ShipCollateralItemEntity | VehicleCollateralItemEntity>();
}
